import { DisplayMode } from "../useResponsiveDisplayMode";

/**
 * Picks the value for a specified display mode.
 * @param displayMode The display mode.
 * @param values The values to get the display mode from.
 * @returns The selected value.
 */
export function pickValueForDisplayMode<T>(values: Partial<Record<DisplayMode, T>>, displayMode: DisplayMode): T | undefined {
  let current = displayMode;


  while (true) {
    if (Object.prototype.hasOwnProperty.call(values, current)) return values[current];

    if (current === "mobile") current = "tablet";
    else if (current === "tablet") current = "smallDesktop";
    else if (current === "smallDesktop") current = "desktop";
    else if (current === "desktop") return undefined;
  }
}
